import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from '@beef/ui-kit';
import { Icon } from 'components';
import styles from './styles.pcss';
import { NotificationComponent } from '../../NotificationComponent';
import { useCopyToClipboard } from '../hooks/useCopyToClipboard';

const cn = classNames.bind(styles);
const MESSAGE_TEXT = 'Ссылка скопирована';
const DURATION = 3000;

export const ServiceDownloadUrl = ({ url, platform, name }) => {
  const [, handleCopy] = useCopyToClipboard();

  return (
    <div className={cn('component')}>
      <Link href={url} className={cn('link')} key={platform} title={name} target="_blank">
        {`Скачать для ${platform}` }
      </Link>
      <NotificationComponent
        duration={DURATION}
        message={MESSAGE_TEXT}
        onClick={() => handleCopy(url)}
      >
        <Icon name="contract" className={cn('icon')} />
      </NotificationComponent>
    </div>
  );
};

ServiceDownloadUrl.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  platform: PropTypes.string,
};
